export default "__VITE_ASSET__BoH4yUcM__"